/**
 * React Query key factory for building attachments.
 *
 * Kept separate from any mass-action hook file — mass-action mutations
 * (task-18) invalidate `list(buildingId)` after a bulk update/destroy but do
 * not own the key shape themselves.
 */
export const buildingAttachmentsKeys = {
    all: ['building-attachments'],
    list: (buildingId) => ['building-attachments', buildingId]
};
